import React from 'react';
import { Button } from './ui/Button';
const CALENDAR_URL = 'https://calendar.app.google/PYPdcRoYne7QrNJA7';
export function CTASection() {
  return <section className="py-20 md:py-32 px-4 bg-[#0a0a0a]" data-id="element-1">
      <div className="max-w-3xl mx-auto text-center" data-id="element-2">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-3">
          Deja de depender de la suerte. <br className="hidden md:block" data-id="element-4" />
          <span className="text-gold" data-id="element-5">Toma el control de tus reservas.</span>
        </h2>
        <p className="text-xl text-gray-400 mb-12" data-id="element-6">
          Agenda una llamada de diagnóstico gratuita y descubre cómo el Sistema
          A.C.E.™ puede llenar tus mesas esta misma semana.
        </p>
        <Button href={CALENDAR_URL} className="w-full md:w-auto shadow-[0_0_40px_rgba(242,183,5,0.2)] text-lg md:text-xl px-10 py-5" data-id="element-7">
          QUIERO MI RESTAURANTE LLENO TODA LA SEMANA
        </Button>
      </div>
    </section>;
}